var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Input from '@web/components/layout/Form/Input';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function TitleFilter(_a) {
    var _b = _a.isDisplayLabel, isDisplayLabel = _b === void 0 ? true : _b;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var title = useFilters().title;
    var onChange = function (title) {
        navigateTo({
            pathname: location.pathname,
            newFilters: {
                title: title
            }
        });
    };
    return (_jsxs("div", __assign({ className: "w-full ", id: "root-portal" }, { children: [isDisplayLabel && (_jsx("label", __assign({ className: "block text-sm font-medium leading-6 text-gray-900" }, { children: t('filters.selectDate') }))), _jsx(Input, { className: "w-full", type: "text", value: title !== null && title !== void 0 ? title : '', onChange: function (value) { return onChange(value); } })] })));
}
